import React from 'react';
import { Box, Container, Link } from '@amzn/awsui-components-core';
import RouterPaths from '../../../common/RouterPaths';

const EmptySearchResult = () => (
  <Box padding={{ top: 'm' }}>
    <Container>
      <p>We are sorry. We could not find any results for your search term.</p>
      <p>
        Please try another search or make a
        <Link variant="secondary" href={RouterPaths.CONTENT_REQUESTS}>
          {' '}
          content suggestion{' '}
        </Link>
        to encourage other authors to create future content.
      </p>
    </Container>
  </Box>
);

export default EmptySearchResult;
